import { getClerkInstance } from "@clerk/clerk-expo";
import { useAppStore } from "@hooks/useAppStore";

/**
 * Auth headers for authenticated hub (`baseNextjsUrl`) requests. Mirrors the
 * app's axios interceptor: a Clerk `jwt-with-user` token in `Authorization`
 * (raw token, no "Bearer " prefix - the hub's auth middleware accepts both)
 * plus the current `tenant-id`. Use for any direct `fetch`/`expo/fetch` call to
 * a Clerk-protected hub route.
 */
const getHubToken = () =>
	getClerkInstance().session?.getToken({ template: "jwt-with-user" });

export const getHubAuthHeaders = async (): Promise<Record<string, string>> => {
	const token = await getHubToken();
	const tenantId = useAppStore.getState().tenant.id;

	const headers: Record<string, string> = {};
	if (token) {
		headers.Authorization = token;
	}
	if (tenantId) {
		headers["tenant-id"] = String(tenantId);
	}
	return headers;
};

/**
 * Authorization-only header for hub routes whose CORS preflight rejects a
 * `tenant-id` header (e.g. `/api/v2/ai/sessionAnalysis`). The tenant is derived
 * server-side from the `jwt-with-user` token instead.
 */
export const getHubTokenHeader = async (): Promise<Record<string, string>> => {
	const token = await getHubToken();
	return token ? { Authorization: token } : {};
};
